import { FireboltForm } from '@iq-firebolt/client'
import FormContainer from 'components/common/FormContainer'
import ActionButtons from 'components/common/ActionButtons'
import SimpleModal from '../../components/SimpleModal'
import './style.styl'
import { FormTitle } from 'components/common/FormTitle'

const CompletaryDataForm = ({
  autofill,
  schema,
  onSubmit,
  remoteErrors,
  theme,
  onGoBack,
  beforeSubmitStep,
  isOpen,
  actionButton,
}) => {
  return (
    <>
      <FormContainer
        className="bbourocard-complementary-data__container"
        imageSrc="images/bb/ourocard-novo.webp">
        <div>
          <FormTitle
            title="Precisamos saber um pouco mais sobre você"
            hasRequiredFieldWarning
          />
          <FireboltForm
            autoFill={autofill}
            schema={schema}
            onSubmit={onSubmit}
            remoteErrors={remoteErrors}
            theme={theme}
            customActionsChild={({ formData }) => (
              <ActionButtons
                formData={formData}
                onGoBack={onGoBack}
                beforeSubmitStep={beforeSubmitStep}
              />
            )}
          />
        </div>
      </FormContainer>
      <SimpleModal
        isOpen={isOpen}
        actionButton={actionButton}
        title="Celular já cadastrado no Banco do Brasil"
        text="O número de celular informado já está cadastrado no Banco do Brasil. Para continuar, é preciso informar um novo número."
        textButton="Informar novo número"
      />
    </>
  )
}

export default CompletaryDataForm
